import { createSvgIcon } from '@mui/material';

const checkboxSquare = (fill: string) => (
  <rect
    fill={fill}
    height='17'
    stroke='currentColor'
    strokeWidth='1'
    vectorEffect='non-scaling-stroke'
    width='17'
    x='3.5'
    y='3.5'
  />
);

export const CheckboxUncheckedIcon = createSvgIcon(checkboxSquare('none'), 'CheckboxUnchecked');

export const CheckboxCheckedIcon = createSvgIcon(
  <g>
    {checkboxSquare('currentColor')}
    <path
      d='M8.2 12.2 10.6 14.6 15.8 9.2'
      fill='none'
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.6'
    />
  </g>,
  'CheckboxChecked',
);

export const CheckboxIndeterminateIcon = createSvgIcon(
  <g>
    {checkboxSquare('currentColor')}
    <path d='M8 12h8' fill='none' stroke='#fff' strokeLinecap='round' strokeWidth='1.6' />
  </g>,
  'CheckboxIndeterminate',
);
